import { render, staticRenderFns } from "./Upload.vue?vue&type=template&id=c90d333a&scoped=true"
import script from "./Upload.vue?vue&type=script&lang=js"
export * from "./Upload.vue?vue&type=script&lang=js"
import style0 from "./Upload.vue?vue&type=style&index=0&id=c90d333a&prod&lang=less"
import style1 from "./Upload.vue?vue&type=style&index=1&id=c90d333a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c90d333a",
  null
  
)

export default component.exports